import type { ValueOf } from '@clearverify/types';

export enum StepId {
  Upload = 'Upload',
  Review = 'Review',
}

export enum TemplateField {
  fein = 'fein',
  feinRegisteredBusinessName = 'feinRegisteredBusinessName',
  feinCommercialName = 'feinCommercialName',
  displayName = 'displayName',
  industry = 'industry',
  corporateStructure = 'corporateStructure',
  taxYearEndDate = 'taxYearEndDate',
  numberOfEmployees = 'numberOfEmployees',
  hqAddress = 'hqAddress',
  hqCity = 'hqCity',
  hqCounty = 'hqCounty',
  hqState = 'hqState',
  hqZipCode = 'hqZipCode',
  contactEmail = 'contactEmail',
  contactPhone = 'contactPhone',
  emailForInvitation = 'emailForInvitation',
}

export const templateSchema = {
  [TemplateField.fein]: 'FEIN',
  [TemplateField.feinRegisteredBusinessName]: 'FEIN Registered Business Name',
  [TemplateField.feinCommercialName]: 'FEIN Commercial Name',
  [TemplateField.displayName]: 'Display Name',
  [TemplateField.industry]: 'Industry',
  [TemplateField.corporateStructure]: 'Corporate Structure',
  [TemplateField.taxYearEndDate]: 'Tax Year End Date',
  [TemplateField.numberOfEmployees]: 'Number of Employees',
  [TemplateField.hqAddress]: 'HQ Address',
  [TemplateField.hqCity]: 'HQ City',
  [TemplateField.hqCounty]: 'HQ County',
  [TemplateField.hqState]: 'HQ State',
  [TemplateField.hqZipCode]: 'HQ ZIP Code',
  [TemplateField.contactEmail]: 'Contact Email',
  [TemplateField.contactPhone]: 'Contact Phone',
  [TemplateField.emailForInvitation]: 'Email for Invitation',
} as const;

export type ExcelEmployerRow = Record<ValueOf<typeof templateSchema>, string>;
